import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/globals.scss'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RouteChangeTracker from './RouteChangeTracker';

import Home from './pages/home/Home';
import Inquire from './pages/inquire/Inquire';
import Header from './components/header/Header';
import Experience from './pages/experience/Experience';
import { RecoilRoot } from 'recoil';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from "react-query/devtools"
import Router from './Router';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
    
    document.getElementById('root') as HTMLElement
);

root.render(
  
    <React.StrictMode>
      <RecoilRoot>
        <QueryClientProvider client={ queryClient }>
          <ReactQueryDevtools initialIsOpen={false}/> 
          <BrowserRouter>
              <Header />    
              <Router/>
          </BrowserRouter>
        </QueryClientProvider>
      </RecoilRoot>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
